module.exports = __webpack_public_path__ + "img/ctrl-hadamard-stub-down-+i.b406477a.svg";